const ID_SEPARATOR = '.';

export function toText(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function toId(value: unknown): number | null {
  const id = Number(toText(value));

  return Number.isFinite(id) && id > 0 ? id : null;
}

export function toIds(value: unknown): number[] {
  return toText(value)
    .split(ID_SEPARATOR)
    .map((part) => toId(part))
    .filter((id): id is number => id !== null);
}

export function toCount(value: unknown): number {
  const count = Number(toText(value));

  return Number.isFinite(count) && count >= 0 ? Math.trunc(count) : 0;
}

export function toFlag(value: unknown): boolean {
  const text = toText(value);

  return Boolean(text) && text !== 'false' && text !== '0';
}

export function toValueList(value: unknown): unknown[] {
  if (Array.isArray(value)) {
    return value;
  }

  return value !== null && typeof value === 'object' ? Object.values(value) : [];
}

export function toAges(value: unknown): number[] {
  const list = toValueList(value);
  if (list.length) {
    return list.map((age) => toCount(age));
  }

  const text = toText(value);

  return text ? [toCount(text)] : [];
}
